import { useEffect } from 'react';
import InputField, {
    InputNumberField,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { TextCapitalize } from '../../../../../utils/TextFormatter';

const billingCycle = [
    { key: 1, value: 'monthly' },
    { key: 3, value: 'quarterly' },
    { key: 6, value: 'half-yearly' },
    { key: 12, value: 'yearly' }
];

function AddDurationType({ formData, handleChange, update = false }) {
    // LimitByValue by default 12
    useEffect(() => {
        if (!formData?.LimitByValue) {
            handleChange({ target: { name: 'LimitByValue', value: 12 } });
        }
    }, [formData, handleChange]);

    return (
        <div className="flex flex-col gap-y-3 mb-4">
            {update ? (
                <InputField
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    disabled
                    required
                />
            ) : (
                <SelectOption
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    options={['thb', 'usd', 'eur', 'bdt']?.map((item) =>
                        addOption(item, item?.toUpperCase(), item)
                    )}
                    required
                />
            )}

            {/* {update ? (
                    <InputField
                        label="Billing Cycle"
                        name="limitByValue"
                        formData={{
                            limitByValue: billingCycle?.find(
                                ({ key }) => key === formData?.limitByValue
                            )?.value
                        }}
                        onChange={handleChange}
                        disabled
                        className="capitalize"
                    />
                ) : (
                    <SelectOption
                        label="Billing Cycle"
                        name="limitByValue"
                        formData={formData}
                        onChange={handleChange}
                        options={billingCycle?.map(({ key, value }) =>
                            addOption(key, TextCapitalize(value), key)
                        )}
                    />
                )} */}

            {/* Duration for */}
            <SelectOption
                label="Duration"
                name="LimitByValue"
                formData={formData}
                onChange={handleChange}
                options={billingCycle?.map(({ key, value }) =>
                    addOption(key, TextCapitalize(value), key)
                )}
                disabled
                required
            />
            <div className="flex gap-3">
                <InputNumberField
                    label="Amount"
                    name="Amount"
                    type="number"
                    placeholder="Type Amount..."
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputNumberField
                    label="Vat(%)"
                    name="VatPercent"
                    placeholder="Type Vat(%)..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>

            {update && (
                <SelectOption
                    label="Status"
                    name="status"
                    formData={formData}
                    onChange={handleChange}
                    options={['active', 'inactive']?.map((item) =>
                        addOption(item, TextCapitalize(item), item)
                    )}
                    required
                />
            )}
        </div>
    );
}

export default AddDurationType;
